module.exports = __webpack_public_path__ + "media/images/icons/outlined/highlight-20600fb9283a0443ac01d137c82c2cf0.svg";